// extracted by mini-css-extract-plugin
export var active = "_jv-2";
export var recordingDot = "_jv-1";
export var recordingIndicator = "_jv-0";